<form class="search"
      [formGroup]="search" [ngClass]="{'search_disabled': isDisabled}">
  <input class="form-control"
         type="text"
         name="search"
         autocomplete="off"
         formControlName="searchInput"
         [attr.maxlength]="maxLength || null"
         [placeholder]="placeholder || ('app.common.search' | translate)"
  >
  <button
    *ngIf="hasSearchValue"
    class="clear-btn"
    type="button"
    [disabled]="isDisabled"
    aria-label="Clear search"
    (click)="clearSearch()"
  >
    <i class="hgi hgi-stroke hgi-cancel-01 icon__clear"></i>
  </button>
  <div class="search-btn">
    <button type="button" tabindex="-1">
        <i class="hgi hgi-stroke hgi-search-01 icon__search"></i>
    </button>
  </div>
</form>



